import React from 'react';

import type { Props as CourseCardProps } from 'Components/Card/Course';

import CourseCard from 'Components/Card/Course';
import { PaginationProps } from 'Components/Pagination';
import GeneralPromoPoint, { GeneralPromoPointProps } from 'Modules/PromoPoint/General';

import { List, Item, PaginationWrapper, NoResults, StyledPagination } from './Course.styled';

export interface Props {
    results: (CourseCardProps & { id: string })[];
    pagination: PaginationProps;
    promoPoint: GeneralPromoPointProps;
}

const Course: React.FC<Props> = props => {
    const { results, pagination, promoPoint } = props;

    return (
        <div>
            {results.length > 0 ? (
                <List>
                    {results.map((item, index) => (
                        <React.Fragment key={item.id}>
                            <Item>
                                <CourseCard {...item} />
                            </Item>
                            {results.length === 8 && index === 3 && (
                                <Item>
                                    <GeneralPromoPoint
                                        {...promoPoint}
                                        showSectionBackground={false}
                                        showSectionWave={false}
                                    />
                                </Item>
                            )}
                        </React.Fragment>
                    ))}
                </List>
            ) : (
                <NoResults>The filters you’ve selected do not match any courses.</NoResults>
            )}
            {results.length > 0 && (
                <PaginationWrapper>
                    <StyledPagination {...pagination} />
                </PaginationWrapper>
            )}
        </div>
    );
};

export default Course;
